import moment from 'moment'
import { createContext } from 'react'

// const INDENT_OVERFLOW_LVL = 7
// const getOverflowMargin = (level) => {
//   if (level >= INDENT_OVERFLOW_LVL) {
//     const howManySeventhLevelsWePassed = level / INDENT_OVERFLOW_LVL
//     const commentOffsetPerLevel = 45
//     const every7LevelsIndent = (INDENT_OVERFLOW_LVL - 1) * commentOffsetPerLevel
//     return -(Math.floor(howManySeventhLevelsWePassed) * every7LevelsIndent - 15)
//   }
//   return 0
// }

const dropdownOptions = [
  { id: 'created', text: 'Most Recent', value: 'created' },
  { id: 'replies', text: 'Most Commented', value: 'replies' },
]

const defaultContext = {
  sortKey: dropdownOptions[0].value,
  readOnly: false,
  comments: [],
  collectionId: '',
  postComment: (a: any) => {},
}
const CommentsContext = createContext(defaultContext)

const getReplyCount = (comments, id) =>
  comments.filter((c) => c.parent_id === id).length

const sortBy = (array, sortKey) => {
  if (!sortKey) return array
  let result = [...array]
  const compareByCreated = (a, b) => moment(b.created).diff(a.created)
  const compareByReplies = (a, b) =>
    getReplyCount(array, b.id) - getReplyCount(array, a.id)

  if (sortKey === 'created') {
    result.sort(compareByCreated)
  }
  if (sortKey === 'replies') {
    result.sort(compareByReplies)
  }

  return result
}

export {
  defaultContext,
  dropdownOptions,
  CommentsContext,
  getReplyCount,
  sortBy,
}
